export default "__VITE_ASSET__9MUiBkAp__"